import { Module } from 'vuex';
import { RootState } from '../types';
import { FarmsState } from './types';
import state from './state';
import mutations from './mutations';
import actions from './actions';
import getters from './getters';

export const farms: Module<FarmsState, RootState> = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
